// For creating scrollable sections with a fixed navbar height
const ScrollSection = ({ id, children }) => (
  <section
    id={id}
    style={{
      scrollMarginTop: '80px', // heigh of navbar
    }}
  >
    {children}
  </section>
);

export default ScrollSection;